import type { EmailMergeDataRequest, EmailMergeDataResponse } from '@/hooks/useEmailMergeData';

/**
 * Demo-mode fabricated response for email merge-data.
 * Used as the demoFn for useEmailMergeData.
 */
export function emailMergeDataDemoResponse(request: EmailMergeDataRequest): EmailMergeDataResponse {
  return {
    recipients: request.recipients.map((r) => ({
      recipientId: r.recipientId,
      mergeData: { email: r.recipientEmail },
      mergeDataHtml: {},
    })),
    unknownPlaceholders: [],
    emptyDataPlaceholders: [],
  };
}
